import { render, staticRenderFns } from "./RegimenExerciseEdit.vue?vue&type=template&id=0b9a6e15"
import script from "./RegimenExerciseEdit.vue?vue&type=script&lang=js"
export * from "./RegimenExerciseEdit.vue?vue&type=script&lang=js"
import style0 from "./RegimenExerciseEdit.vue?vue&type=style&index=0&id=0b9a6e15&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports